import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _31b7f564 = () => interopDefault(import('../pages/30-jahre-telekom.vue' /* webpackChunkName: "pages/30-jahre-telekom" */))
const _3a111a3d = () => interopDefault(import('../pages/30-jahre-telekom-endgeraete.vue' /* webpackChunkName: "pages/30-jahre-telekom-endgeraete" */))
const _c33a2c7e = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _31211016 = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _4b4abc3c = () => interopDefault(import('../pages/bitte-kommen-sie-spaeter-wieder.vue' /* webpackChunkName: "pages/bitte-kommen-sie-spaeter-wieder" */))
const _976b5738 = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _6534df51 = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _d4587ae2 = () => interopDefault(import('../pages/handyvergleich.vue' /* webpackChunkName: "pages/handyvergleich" */))
const _5835b7e6 = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _1b2f2d68 = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _97d2d04a = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _29d8bf9e = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _4a0fb21a = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _4f223c26 = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _320b31bd = () => interopDefault(import('../pages/ratenzahlung.vue' /* webpackChunkName: "pages/ratenzahlung" */))
const _652df5ce = () => interopDefault(import('../pages/redirecting.vue' /* webpackChunkName: "pages/redirecting" */))
const _3a040376 = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _c85b1f74 = () => interopDefault(import('../pages/samsung-cashback-aktion.vue' /* webpackChunkName: "pages/samsung-cashback-aktion" */))
const _5d3c2c3b = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _7e0eb714 = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _443f7243 = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _5ff43eec = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _1c5c9521 = () => interopDefault(import('../pages/urlaubsessentials.vue' /* webpackChunkName: "pages/urlaubsessentials" */))
const _48f69023 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _cf2c66b8 = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _6c3d0a68 = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _1ed8b870 = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _241d0111 = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _2a6951a9 = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _0a7c0915 = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _07c96876 = () => interopDefault(import('../pages/magenta-black-days/page-data.js' /* webpackChunkName: "pages/magenta-black-days/page-data" */))
const _7b576000 = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _59da5865 = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _0e485354 = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _9f09e61e = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _49e6cb96 = () => interopDefault(import('../pages/shop/kundenformular.vue' /* webpackChunkName: "pages/shop/kundenformular" */))
const _6915c999 = () => interopDefault(import('../pages/shop/kundenformular/index.vue' /* webpackChunkName: "pages/shop/kundenformular/index" */))
const _787e9fc6 = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _1ffd1b3a = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _3c5eb3d3 = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _68b06bc0 = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _29ca5d0c = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _3fc1c298 = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _265a3128 = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _43f46db0 = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _6472202c = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _168ff635 = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _1a8161f2 = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _1f07fc89 = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _63c05a1a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3528b561 = () => interopDefault(import('../pages/magenta-moments-2024/_slug.vue' /* webpackChunkName: "pages/magenta-moments-2024/_slug" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/30-jahre-telekom",
    component: _31b7f564,
    name: "30-jahre-telekom"
  }, {
    path: "/30-jahre-telekom-endgeraete",
    component: _3a111a3d,
    name: "30-jahre-telekom-endgeraete"
  }, {
    path: "/a-good-company",
    component: _c33a2c7e,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _31211016,
    name: "anker"
  }, {
    path: "/bitte-kommen-sie-spaeter-wieder",
    component: _4b4abc3c,
    name: "bitte-kommen-sie-spaeter-wieder"
  }, {
    path: "/google",
    component: _976b5738,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _6534df51,
    name: "handyrechnung-aktion"
  }, {
    path: "/handyvergleich",
    component: _d4587ae2,
    name: "handyvergleich"
  }, {
    path: "/infos-zum-online-kauf",
    component: _5835b7e6,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _1b2f2d68,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _97d2d04a,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _29d8bf9e,
    name: "merkliste"
  }, {
    path: "/panzerglass",
    component: _4a0fb21a,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _4f223c26,
    name: "preisvorteile-sichern"
  }, {
    path: "/ratenzahlung",
    component: _320b31bd,
    name: "ratenzahlung"
  }, {
    path: "/redirecting",
    component: _652df5ce,
    name: "redirecting"
  }, {
    path: "/samsung",
    component: _3a040376,
    name: "samsung"
  }, {
    path: "/samsung-cashback-aktion",
    component: _c85b1f74,
    name: "samsung-cashback-aktion"
  }, {
    path: "/smart-home-entdecken",
    component: _5d3c2c3b,
    name: "smart-home-entdecken"
  }, {
    path: "/soundcore",
    component: _7e0eb714,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _443f7243,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _5ff43eec,
    name: "themenwelten"
  }, {
    path: "/urlaubsessentials",
    component: _1c5c9521,
    name: "urlaubsessentials"
  }, {
    path: "/xiaomi",
    component: _48f69023,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _cf2c66b8,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _6c3d0a68,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _1ed8b870,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _241d0111,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _2a6951a9,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _0a7c0915,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/magenta-black-days/page-data",
    component: _07c96876,
    name: "magenta-black-days-page-data"
  }, {
    path: "/samsung/product-data",
    component: _7b576000,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _59da5865,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _0e485354,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _9f09e61e,
    name: "shop-fehler"
  }, {
    path: "/shop/kundenformular",
    component: _49e6cb96,
    children: [{
      path: "",
      component: _6915c999,
      name: "shop-kundenformular"
    }, {
      path: "persoenliche-daten",
      component: _787e9fc6,
      name: "shop-kundenformular-persoenliche-daten"
    }, {
      path: "zahlungsart",
      component: _1ffd1b3a,
      name: "shop-kundenformular-zahlungsart"
    }]
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _3c5eb3d3,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _68b06bc0,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _29ca5d0c,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _3fc1c298,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _265a3128,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _43f46db0,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _6472202c,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _168ff635,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _1a8161f2,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _1f07fc89,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/",
    component: _63c05a1a,
    name: "index"
  }, {
    path: "/magenta-moments-2024/:slug?",
    component: _3528b561,
    name: "magenta-moments-2024-slug"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
